import React from 'react'
import { deleteAppointments, updateAppointmentsWorkflow } from '../network/appointment';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App, Button, Flex } from 'antd';
import { queryKeys } from '../services/react-query/queryKeys';
import { useNavigate } from 'react-router-dom';

const ChangeStauts = ({ status, edit, t }) => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const client = useQueryClient();
  const { mutate: updateAppointmentStatus, isLoading: loadingUpdateStatus } =
    useMutation({
      mutationFn: (status) => updateAppointmentsWorkflow(status),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({ queryKey: [queryKeys.getAppointments] });
        // form.resetFields();
        navigate('/appointments');
      },
      onError: (error) => {
        console.log(error, 'error');
      },
    });
             const handleRemove = useMutation(
               // (id) => deletePatient(id),
               {
                 mutationFn: (id) => deleteAppointments(id),
                 onSuccess: (data) => {
                   console.log(data?.message, 'datawwww');
                   if (data?.message?.status === 500) {
                     message.error(data?.message?.message);
                     return false;
                   }
                   message.success(data?.message?.message);
                   //  message.success('تم الحذف بنجاح');
                   client.invalidateQueries({
                     queryKey: [queryKeys.getAppointments],
                   });
                   navigate('/appointments');
                 },
                 onError: () => {
                   message.error('حدث خطأ ما');
                 },
               }
             );
  return (
    <Flex
      justify="space-between"
      align="center"
      // direction="column"
      wrap
      gap="small"
      style={{ marginBottom: 20 }}
    >
      <h4 className="title-card">{t.titleCardAddPatient}</h4>
      {edit && status?.message?.message?.workflow_state === 'Scheduled' && (
        <Flex wrap gap="small">
          <Button
            type="primary"
            style={{
              background: '#87d068',
            }}
            onClick={() =>
              updateAppointmentStatus({
                record: status?.message?.message?.name,
                status: 'Confirm',
              })
            }
            loading={loadingUpdateStatus}
          >
            {t.confirm}
          </Button>
          <Button
            type="primary"
            danger
            onClick={() =>
              updateAppointmentStatus({
                record: status?.message?.message?.name,
                status: 'Cancel',
              })
            }
          >
            {t.reject}
          </Button>
        </Flex>
      )}
      {edit && status?.message?.message?.workflow_state === 'Confirmed' && (
        <Flex wrap gap="small">
          <Button
            type="primary"
            style={{
              background: '#68d0d0',
            }}
            onClick={() =>
              updateAppointmentStatus({
                record: status?.message?.message?.name,
                status: 'Pending',
              })
            }
            loading={loadingUpdateStatus}
          >
            {t.pending}
          </Button>
          <Button
            type="primary"
            style={{
              background: '#2385d4',
            }}
            onClick={() =>
              updateAppointmentStatus({
                record: status?.message?.message?.name,
                status: 'Check In',
              })
            }
          >
            {t.checkIn}
          </Button>
        </Flex>
      )}
      {edit &&
        status?.message?.message?.workflow_state ===
          'Pending to complete patient file' && (
          <Button
            type="primary"
            style={{
              background: '#2385d4',
            }}
            onClick={() =>
              updateAppointmentStatus({
                record: status?.message?.message?.name,
                status: 'Check In',
              })
            }
          >
            {t.checkIn}
          </Button>
        )}
      {edit && status?.message?.message?.workflow_state === 'Checked In' && (
        <Button
          type="primary"
          style={{
            background: '#2385d4',
          }}
          onClick={() =>
            updateAppointmentStatus({
              record: status?.message?.message?.name,
              status: 'Open',
            })
          }
        >
          {t.open}
        </Button>
      )}
      {edit && status?.message?.message?.workflow_state === 'Open' && (
        <Button
          type="primary"
          style={{
            background: '#e41934',
          }}
          onClick={() =>
            updateAppointmentStatus({
              record: status?.message?.message?.name,
              status: 'Checked Out',
            })
          }
        >
          {t.checkedOut}
        </Button>
      )}
      {/* {edit && status?.message?.message?.workflow_state === 'Checked Out' && (
        <Button
          type="primary"
          style={{
            background: '#e41934',
          }}
        //   onClick={() =>
        //     // handleRemove.mutate(status?.message?.message?.name)
        //   }
        onClick={() =>handleRemove.mutate(status?.message?.message?.name)}
        >
          {t.delete}
        </Button>
      )} */}
    </Flex>
  );
};

export default ChangeStauts